export const selectProposalNotificationsData = (state) =>
  state.proposals.notificationsWidget.data;

export const selectProposalNotificationsLoading = (state) =>
  state.proposals.notificationsWidget.isLoading;

export const selectProposalNotificationsError = (state) =>
  state.proposals.notificationsWidget.error;
